import Component from '../../../assets/scripts/modules/component'

function keepScrollPosition () {
  const scrollPosition = localStorage.getItem('TBM_SCROLL_POSITION')

  if (scrollPosition) {
    localStorage.removeItem('TBM_SCROLL_POSITION')
    window.scrollTo({ top: parseInt(scrollPosition, 10), behavior: 'instant' })
  }
}

class TabBarComponent extends Component {
  init () {
    this.keepScrollPosition()
  }

  keepScrollPosition () {
    keepScrollPosition()
    this.element.querySelectorAll('a').forEach((link) => {
      if (link.getAttribute('href').startsWith('#') || new URL(link.getAttribute('href')).pathname !== window.location.pathname) {
        return
      }

      link.addEventListener('click', () => {
        localStorage.setItem('TBM_SCROLL_POSITION', '' + window.scrollY)
      })
    })
  }
}

window.addEventListener('init-load', () =>
  document.querySelectorAll('.tab-bar').forEach((element) => {
    element.instance = element.instance || new TabBarComponent(element)
  })
)
